<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data">
      <vx-card :title="titleCard" class="mb-base">
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <div>
              <vs-input
                class="w-full mt-4"
                label="Identificador"
                v-model="etapa.IDETAPA"
                v-validate="'required'"
                name="identifier"
                :disabled="!modeCreate"
                type="number"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('IDETAPA') || formerr.includes('IDETAPA')"
              >Por favor ingrese el identificador de la Etapa</span>

              <vs-input
                class="w-full mt-4"
                label="Nombre de la etapa"
                v-model="etapa.NOMBRE"
                v-validate="'required'"
                name="NOMBRE"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('NOMBRE') || formerr.includes('NOMBRE')"
              >Por favor ingrese el nombre de la Etapa</span>
            </div>
          </div>

          <div class="vx-col w-full md:w-1/2">
            <div>
              <vs-select
                v-model="etapa.IDLICITACION"
                label="Contratación asociada"
                class="mt-5 w-full"
                name="item-type-etapa"
                :disabled="this.licitacionProp !== null && this.licitacionProp !== undefined"
              >
                <vs-select-item />
                <vs-select-item
                  :key="item.IDLICITACION"
                  :value="item.IDLICITACION"
                  :text="item.IDLICITACION"
                  v-for="item in licitaciones"
                />
              </vs-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('IDLICITACION') || formerr.includes('IDLICITACION')"
              >Por favor seleccione la contratación asociada</span>

              <div class="w-full mt-4">
                <label for="fechaInicial" class="vs-input--label">Fecha inicial</label>
                <flat-pickr
                  class="vs-inputx vs-input--input normal"
                  id="fechaInicial"
                  :config="configdateIni"
                  v-model="etapa.FECHA_INI"
                  placeholder="aaaa-mm-dd H:m:s"
                  @on-change="onFromChange"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('FECHA_INI') || formerr.includes('FECHA_INI')"
                >Por favor seleccione la fecha de inicio de la etapa</span>
              </div>

              <div class="w-full mt-4">
                <label for="fechaFinal" class="vs-input--label">Fecha final</label>
                <flat-pickr
                  class="vs-inputx vs-input--input normal"
                  id="fechaFinal"
                  :config="configdateFin"
                  v-model="etapa.FECHA_FIN"
                  placeholder="aaaa-mm-dd H:m:s"
                  @on-change="onToChange"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('FECHA_FIN') || formerr.includes('FECHA_FIN')"
                >Por favor seleccione la fecha final de la etapa</span>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <div class="vx-col w-full flex" id="account-manage-buttons">
        <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
        <vs-button type="border" color="danger" icon-pack="feather" @click="closeSidebar">Cancelar</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import CasoSidebar from '@/views/caso/CasoSidebar.vue'
import CasoModule from '@/store/caso-module/moduleDataList.js'
import EtapaCasoModule from '@/store/etapa-caso-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'

export default {
  components: {
    Datepicker,
    CasoSidebar,
    flatPickr
  },
  props: {
    propEtapaData: {
      type: Object,
      default: () => {}
    },
    licitacionProp: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      titleCard: '', // Crear/Modificar Etapa
      modeCreate: true, // Crear => true/Modificar => false
      formerr: [], // Crear => true/Modificar => false,
      etapa: {},
      id: -1,
      name: '',
      nit: '',
      representative: '',
      address: '',
      phone: '',
      email: '',
      user_data: {},
      user_not_found: false,
      dob: new Date(),
      configdateIni: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S ',
        locale: SpanishLocale,
        enableSeconds: true,
        maxDate: null
      },
      configdateFin: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S ',
        locale: SpanishLocale,
        enableSeconds: true,
        minDate: null
      }
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    },
    validateForm () {
      return !this.errors.any() && this.formerr.length <= 0
    },
    licitaciones () {
      return this.$store.state.CasoModule.licitaciones
    }
  },
  created () {
    this.initParams()
    this.initListOfValues()
  },
  watch: {
    propEtapaData () {
      this.initParams()
    },
    licitacionProp () {
      this.initParams()
    }
  },
  methods: {
    initListOfValues () {
      this.$vs.loading()

      if (!CasoModule.isRegistered) {
        this.$store.registerModule('CasoModule', CasoModule)
        CasoModule.isRegistered = true
      }

      this.$store.dispatch('CasoModule/getAllLicitaciones').then(() => {
        this.$vs.loading.close()
      }).catch(() =>  {
        this.$vs.loading.close()

        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text:
              'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
          acceptText: 'Aceptar'
        })
      })
    },
    initParams (force = false) {
      if (
        force ||
        (this.propEtapaData !== null && this.propEtapaData.IDETAPA === null) ||
        this.propEtapaData.IDETAPA === undefined ||
        this.propEtapaData.IDETAPA === ''
      ) {
        //Se Utiliza JSON.parse para evitar que la variable quede bindeada al estado en vuex
        this.etapa = JSON.parse(JSON.stringify(this.propEtapaData))
        this.modeCreate = true
        this.titleCard = 'Crear Etapa'
      } else {
        this.modeCreate = false
        this.etapa = JSON.parse(JSON.stringify(this.propEtapaData))
        this.titleCard = 'Modificar Etapa'
      }

      // Si llega la contratación, asignarsela a la etapa
      console.log('Pregunto si llega la contratación: ', this.licitacionProp)
      if (
        this.licitacionProp !== undefined &&
        this.licitacionProp.IDLICITACION !== null &&
        this.licitacionProp.IDLICITACION !== undefined &&
        this.licitacionProp.IDLICITACION !== ''
      ) {
        this.etapa.IDLICITACION = this.licitacionProp.IDLICITACION
        console.log('Asignando la contratación: ', this.etapa)
      }

      this.$validator.reset()
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la Etapa "${this.etapaName}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    displayMessage () {
      this.$vs.dialog({
        color: 'primary',
        title: 'Modificar registro',
        text: `Modificación de Etapa id=${  this.etapaId}`
      })
    },
    deleteRecord () {
      this.showDeleteSuccess()
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Etapa eliminada',
        text:
          `La Etapa "${  this.etapaName  }" ha sido eliminada del sistema.`
      })
    },
    closeSidebar () {
      this.$emit('closeEdit')
      this.initParams(true)
    },
    actionSaveData () {
      // this.initRelations();
      this.formerr = []

      if (
        this.etapa.IDETAPA === null ||
        this.etapa.IDETAPA === undefined ||
        this.etapa.IDETAPA.toString().trim() === ''
      ) {
        this.formerr.push('IDETAPA')
      }
      if (
        this.etapa.IDLICITACION === null ||
        this.etapa.IDLICITACION === undefined ||
        this.etapa.IDLICITACION.trim() === ''
      ) {
        this.formerr.push('IDLICITACION')
      }
      if (
        this.etapa.NOMBRE === null ||
        this.etapa.NOMBRE === undefined ||
        this.etapa.NOMBRE.trim() === ''
      ) {
        this.formerr.push('NOMBRE')
      }
      if (
        this.etapa.FECHA_INI === null ||
        this.etapa.FECHA_INI === undefined ||
        this.etapa.FECHA_INI === ''
      ) {
        this.formerr.push('FECHA_INI')
      }
      if (
        this.etapa.FECHA_FIN === null ||
        this.etapa.FECHA_FIN === undefined ||
        this.etapa.FECHA_FIN === ''
      ) {
        this.formerr.push('FECHA_FIN')
      }
      if (this.validateForm) {
        if (this.modeCreate) {
          this.createNewetapa()
        } else {
          this.editetapa(this.etapa)
        }
      } else {
        console.log('Hay errores que resolver', this.errors)
      }
    },
    createNewetapa () {
      this.$store
        .dispatch('EtapaCasoModule/addEtapa', this.etapa)
        .then(() => {
          const etapaNameTmp = this.etapa.NOMBRE
          this.$emit('closeEdit')
          this.initParams(true) // Limpiar campos del formulario
          this.$vs.notify({
            color: 'success',
            title: 'Etapa creada',
            text:
              `La Etapa "${  etapaNameTmp  }" ha sido creada correctamente.`
          })
        })
        .catch((ex) => {
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOk !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },
    editetapa (etapaData) {
      this.$store
        .dispatch('EtapaCasoModule/updateEtapa', etapaData)
        .then(() => {
          const etapaNameTmp = this.etapa.NOMBRE
          this.$emit('refresh')
          this.$emit('closeEdit')
          this.initParams(true) // Limpiar campos del formulario
          this.$vs.notify({
            color: 'success',
            title: 'Etapa actualizada',
            text:
              `La Etapa "${ 
                etapaNameTmp 
              }" ha sido actualizada correctamente.`
          })
        })
        .catch((ex) => {
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOk !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },
    onFromChange (selectedDates, dateStr, instance) {
      this.$set(this.configdateFin, 'minDate', dateStr)
    },
    onToChange (selectedDates, dateStr, instance) {
      this.$set(this.configdateIni, 'maxDate', dateStr)
    }
  }
}
</script>

<style lang="scss">
::v-deep .etapa-edit {
  height: 100%;
}

#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
